module.exports = __webpack_public_path__ + "static/media/west-midlands.f8d35e6e.png";